'use client';
import React from 'react';

import {
  currentPaginationPageAtom,
  isBlogSearchReadyAtom,
  searchFiltersAtom,
  searchQueryAtom,
} from '@/store/blogStore';
import { useAtomValue } from 'jotai';
import { BlogSearchResultsListView } from './BlogSearchResultsListView';
import { BlogSearchListDefault } from './BlogSearchListDefault';
import PaginatedPostsLoader from './PaginatedPostsLoader';

export default function PaginatedPosts() {
  const searchQuery = useAtomValue(searchQueryAtom);
  const currentPage = useAtomValue(currentPaginationPageAtom);
  const searchFilters = useAtomValue(searchFiltersAtom);
  // at least one of the search filters should be present and have a value
  const hasSearchFilters = Object.values(searchFilters).some((val) => !!val);

  const blogSearchIsReady = useAtomValue(isBlogSearchReadyAtom);

  if (!blogSearchIsReady) {
    return <PaginatedPostsLoader />;
  }

  return (
    <section className='flex flex-col gap-10 sm:gap-16'>
      {!searchQuery && !hasSearchFilters ? (
        <BlogSearchListDefault page={currentPage ? Number(currentPage) : 1} />
      ) : (
        <BlogSearchResultsListView
          page={currentPage ? Number(currentPage) : 1}
          query={searchQuery as string}
          searchFilters={searchFilters}
        />
      )}
    </section>
  );
}
